import docx_svg from "../assets/docx.svg";
import md_svg from "../assets/md.svg";
import html_svg from "../assets/html.svg";
import pdf_svg from "../assets/pdf_disp.svg";
import png_svg from "../assets/png.svg";
import rag_svg from "../assets/pdf.svg";
import chat_svg from "../assets/chatbot.svg";
import jpg_svg from "../assets/jpg.svg";
import txt_svg from "../assets/text.svg";
import database_svg from "../assets/sql.svg";
import excel_svg from "../assets/csv.svg";
import youtube_svg from "../assets/youtube.svg";
import neo4j_svg from "../assets/neo4j.svg";

const data: { [index: string]: any } = {
  pdf: pdf_svg,
  html: html_svg,
  md: md_svg,
  docx: docx_svg,
  png: png_svg,
  rag: rag_svg,
  default: chat_svg,
  jpg: jpg_svg,
  txt: txt_svg,
  sql: database_svg,
  excel: excel_svg,
  yt: youtube_svg,
  neo4j: neo4j_svg,
};

export default data;
